// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "frontend-assets/css/" + chunkId + "." + {"22":"1c396102","91":"241f3400","319":"431f1011","576":"080e3cb2","611":"60b4914c","871":"53cc925c","922":"b6462807"}[chunkId] + ".css";
};